import { NavLink } from "react-router-dom";
import "./AdminLayout.css";

interface AdminSidebarProps {
  closeSidebar?: () => void;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({ closeSidebar }) => {

    return (

        <aside className="admin-sidebar">           

            <NavLink to="/admin"  onClick={() => closeSidebar?.()}>

                Dashboard

            </NavLink>

            <NavLink to="/admin/groups"  onClick={() => closeSidebar?.()}>

                Groups

            </NavLink>

            <NavLink to="/admin/groups/create"  onClick={() => closeSidebar?.()}>

                Create Group

            </NavLink>

            <NavLink to="/admin/group-requests"   onClick={() => closeSidebar?.()}>

                Group Requests

            </NavLink>
       
{/* 
            <NavLink to="/admin">

                Join Requests

            </NavLink> */}

            <NavLink to="/admin/users"  onClick={() => closeSidebar?.()}>

                Users

            </NavLink>
            

            <NavLink 
         to="/admin/Contact-Information"  onClick={() => closeSidebar?.()}>

                Contact Information

            </NavLink>

        </aside>

    );

};

export default AdminSidebar;